var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTurkey(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 12,
    viewBox: "0 0 18 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group 1000002834"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M17.6 10.1538C17.6 10.6435 17.6 12 17.6 12C17.6 12 16.1631 12 15.6445 12H1.95573C1.43709 12 0 12 0 12C0 12 0.000193648 10.6435 0.000193648 10.1538V1.84618C0.000193648 1.35655 1.66096e-06 0 1.66096e-06 0C1.66096e-06 0 1.43709 2.79362e-05 1.95573 2.79362e-05H15.6445C16.1631 2.79362e-05 17.6 2.79362e-05 17.6 2.79362e-05C17.6 2.79362e-05 17.6 1.35655 17.6 1.84618V10.1538Z",
    fill: "#E30917"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M7.82253 8.76838C7.04457 8.76838 6.29847 8.47662 5.74837 7.95729C5.19827 7.43796 4.88923 6.7336 4.88923 5.99915C4.88923 5.26471 5.19827 4.56035 5.74837 4.04102C6.29847 3.52169 7.04457 3.22993 7.82253 3.22993C8.46297 3.22993 9.05451 3.42608 9.53704 3.75516C9.20062 3.39388 8.78648 3.10447 8.32223 2.90622C7.85798 2.70797 7.35429 2.60544 6.84476 2.60547C5.89137 2.60547 4.97703 2.96302 4.30288 3.59946C3.62873 4.2359 3.25 5.09909 3.25 5.99915C3.24994 6.44486 3.34287 6.88621 3.52349 7.298C3.70412 7.7098 3.9689 8.08397 4.30271 8.39915C4.63652 8.71433 5.03282 8.96435 5.46899 9.13493C5.90516 9.3055 6.37265 9.3933 6.84476 9.3933C7.91786 9.3933 8.87852 8.94699 9.53704 8.24315C9.03866 8.58482 8.43846 8.76869 7.82253 8.76838ZM9.73553 6.10531L10.9284 6.36469L11.036 7.5153L11.6656 6.52484L12.8585 6.78377L12.0548 5.91238L12.684 4.92146L11.5581 5.37377L10.7544 4.50193L10.8619 5.653L9.73553 6.10531Z",
    fill: "#EEEEEE"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTurkey);
export default __webpack_public_path__ + "static/media/turkey.39f9eaa930e13a84dfdd7302c83494b9.svg";
export { ForwardRef as ReactComponent };